import classNames from 'classnames'
import EmptyHolder from 'components/EmptyHolder'
import getLinkToDetail from 'helpers/getLinkToDetail'
import _ from 'lodash'
import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {getResponseItem, renderIf, renderSelf} from 'views/Shared'
import {flatten_rows} from './codiHelpers'
import {Modal} from "antd";
import useTranslate from "../../../modules/local/useTranslate";
import {useHistory} from "../../../modules/navigation/useRouter";
import {HeaderBlock} from "../../MainPage/components/HeaderBlock";
import {BsHash} from "react-icons/bs";
import {doc_getKeywordDefinitionById_Api} from "../../../apis";
import useAsyncAction from "../../../modules/asyncCache/useAsyncAction";

const CodiKeywords = ({
                          row,
                          style,
                          className,
                          render = renderSelf,
                          Placeholder = EmptyHolder,
                      }) => {
    const history = useHistory()
    const t = useTranslate()
    const [keyword, setKeyword] = useState()
    const [dataDefinitions, setDataDefinitions] = useState()
    const keywords = _.uniqBy(flatten_rows(row, 'keywords'), 'id')

    const {
        isLoading,
        handleAsyncAction: lookupInfo,
    } = useAsyncAction({
        apiInfo: doc_getKeywordDefinitionById_Api,
        onSuccess: (__, {response}) => {
            setDataDefinitions(getResponseItem(response))
        },
    })


    useEffect(() => {
        if (keyword) {
            lookupInfo({}, {id: keyword?.id})
        }
    }, [keyword])

    if (_.isEmpty(keywords)) {
        return <Placeholder/>
    }

    return (
        render(
            <div
                style={style}
                className={classNames(
                    'px-2 flex flex-wrap gap-x-4 gap-y-3',
                    className
                )}>
                {keywords.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => {
                            setKeyword(item)
                        }}
                        style={{cursor: 'pointer'}}
                        className="font-medium hover:font-bold text-xs text-color-300 hover:text-primary italic scale-animation-xs CodiKeyword">
                        {item?.keyword}
                    </div>
                ))}
                {renderIf(
                    keyword,
                    <Modal
                        width={620}
                        open={keyword}
                        cancelText={t('close')}
                        onCancel={() => {
                            setKeyword(null)
                        }}
                        title={
                            <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                                {t('view keyword')}
                            </div>
                        }
                        destroyOnHidden={true}
                        className="custom-modal"
                        footer={null}>
                        <div className="flex flex-col gap-3">
                            <HeaderBlock
                                size={26}
                                icon={<BsHash size={16} className="text-color-200"/>}
                                className="background-200"
                                renderTitle={() => (
                                    <div className="space-x-1 text-color-200">
                                        <span className="font-normal text-sm italic">
                                            {`${t('you are seeing')} ${t('keyword')}: `}
                                        </span>
                                        <span className="font-bold text-base">
                                            {keyword?.keyword}
                                        </span>
                                    </div>
                                )}
                            />
                            {renderIf(
                                keyword?.description,
                                <span className="text-sm text-color-300 tracking-wider">
                                    {keyword?.description}
                                </span>
                            )}
                            <div className="ml-2 flex flex-col gap-4">
                                <span className="font-medium text-sm text-blue-600 tracking-wide">
                                    {`${t('related lexicon')}: `}
                                </span>
                                <div className="flex flex-col gap-4">
                                    {dataDefinitions?.map((e, i) => (
                                        <div key={i} className="p-2 flex flex-col gap-1 border-t border-color-50 shadow-md rounded-lg hover:scale-2xs text-sm">
                                            <span className="font-medium text-color-000">
                                                {`${e?.title}: `}
                                            </span>
                                            <ul style={{paddingLeft: 18, listStyleType: 'circle'}}
                                                className="ml-2 space-y-1 max-lines-3">
                                                {e?.definition_details.map((ee, ii) => (
                                                    <li key={ii} className="text-sm text-color-300 tracking-wide">
                                                        {ee?.content}
                                                    </li>
                                                ))}
                                            </ul>
                                            <div className="mt-1 text-right">
                                                <Link
                                                    to={getLinkToDetail(e)}
                                                    className="text-xs text-color-400 italic tracking-wide no-underline">
                                                    {`${t('view lexicon')}...`}
                                                </Link>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="mt-6 flex flex-center gap-3">
                            <Link to={getLinkToDetail(keyword)} className="no-underline">
                                <div
                                    style={{padding: '4px 12px', height: 28}}
                                    className="bg-secondary-50 hover:bg-secondary-100 rounded-lg font-medium text-xs text-secondary-600 tracking-wider">
                                    {t('view detail')} {t('keyword')}
                                </div>
                            </Link>
                        </div>
                    </Modal>
                )}
            </div>
        ) ?? null
    )
}

export default CodiKeywords
